/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M17.6 11.2H6.4c-2.651 0-4.8-2.149-4.8-4.8s2.149-4.8 4.8-4.8h10.4a.8.8 0 0 0 0-1.6H6.4C2.8654 0 0 2.8654 0 6.4s2.8654 6.4 6.4 6.4h11.2c2.651 0 4.8 2.149 4.8 4.8s-2.149 4.8-4.8 4.8H7.2a.8.8 0 0 0 0 1.6h10.4c3.5346 0 6.4-2.8654 6.4-6.4s-2.8654-6.4-6.4-6.4Z"
    clipRule="evenodd"
  />,
  'Path'
);
